import { FC } from 'react';
import { CellProps, GridProps } from './Grid.types';
import * as S from './Grid.styled';

export const Grid: FC<GridProps> = ({
    gap,
    rowGap,
    columnGap,
    mobileGap,
    tabletGap,
    desktopGap,
    mobileRowGap,
    tabletRowGap,
    desktopRowGap,
    mobileColumnGap,
    tabletColumnGap,
    columns,
    mobileColumns,
    responsive,
    flow,
    minRowHeight,
    minRowHeightMobile,
    minRowHeightTablet,
    height,
    rows,
    areas,
    justifyContent,
    alignContent,
    ...props
}) => {
    return (
        <S.Grid
            $gap={gap}
            $rowGap={rowGap}
            $columnGap={columnGap}
            $mobileGap={mobileGap}
            $tabletGap={tabletGap}
            $desktopGap={desktopGap}
            $mobileRowGap={mobileRowGap}
            $tabletRowGap={tabletRowGap}
            $desktopRowGap={desktopRowGap}
            $mobileColumnGap={mobileColumnGap}
            $tabletColumnGap={tabletColumnGap}
            $columns={columns}
            $mobileColumns={mobileColumns}
            $responsive={responsive}
            $flow={flow}
            $minRowHeight={minRowHeight}
            $minRowHeightMobile={minRowHeightMobile}
            $minRowHeightTablet={minRowHeightTablet}
            height={height}
            $rows={rows}
            $areas={areas}
            $justifyContent={justifyContent}
            $alignContent={alignContent}
            {...props}
        />
    );
};

export const Cell: FC<CellProps> = ({
    width,
    tabletWidth,
    mobileWidth,
    height,
    top,
    left,
    middle,
    center,
    area,
    ...props
}) => {
    return (
        <S.Cell
            $width={width}
            $tabletWidth={tabletWidth}
            $mobileWidth={mobileWidth}
            $height={height}
            $top={top}
            $left={left}
            $middle={middle}
            $center={center}
            $area={area}
            {...props}
        />
    );
};
